<mat-dialog-content>
    <form [formGroup]="form" class="flex-direction-column flex-around-center">
        <mat-form-field appearance="fill">
            <mat-label>{{'email'|translate}}</mat-label>
            <input matInput formControlName="email">
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>{{'phone_required'|translate}}</mat-label>
            <input matInput formControlName="phone">
        </mat-form-field>
        <app-auto-complete-form
                formControlName="houseId"
                [title]="'project'|translate"
                [items]="this.data.projectPossibleValues|transformValueByPredicateFunction:predicatePossibleValue"
        >

        </app-auto-complete-form>
    </form>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-flat-button color="accent" [mat-dialog-close]="undefined">
        <mat-icon>clear</mat-icon>
    </button>
    <button mat-flat-button color="primary" [disabled]="form.invalid" (click)="confirmValue()">
        <mat-icon>check</mat-icon>
    </button>
</mat-dialog-actions>